import HttpStatus from "../../../../../constants/HttpStatus";
import axiosInstance from "../../../../../services/AxiosInstance";

export const searchAddressByZipCode = async (zipCode) => {
  try {
    const zipCodeOnlyNumbers = zipCode.replace(/\D/g, '');
    const response = await axiosInstance.get(`/api/address/${zipCodeOnlyNumbers}`);
    const addressData = response.data;

    const returnedZipCode = addressData.zipCode.replace(/\D/g, '');

    if (returnedZipCode === zipCodeOnlyNumbers) {
      return addressData; // Return the address data if zip codes match
    } else {
      throw new Error('No matching address found for zip code: ' + zipCode); // Throw an error for unmatched zip code
    }
  } catch (error) {
    throw new Error('validation.not_found.zipCode');
  }
};